<template lang="pug">
section
  s-page-title(v-if="meta.advantage" :title='meta.advantage.name' :previous='true')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card(v-if="meta.advantage && meta.advantage.uniqueness_code")
    v-alert(
      :value="true"
      color="warning"
      icon="warning"
      outline
    ) Данное преимущество является уникальным и назначение объектам ведется в 1С. Все внесенные изменения в данном интерфейсе будут аннулированы после очередной выгрузки из 1С!
  v-card
    s-data-filter(:initial='dataFilter.search' @search='debouncedSearch')
      template(slot='controls')
        v-layout
          v-flex(xs12)
            s-complex-picker(
              :value='dataFilter.complex_id'
              @change='changeComplex'
              clearable
            )
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      :rows-per-page-items='dataFilter.rowsPerPageItems'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item)')
          td {{ props.item.id }}
          td {{ props.item.complex_name }}
          td {{ props.item.objects_name }}
          td {{ props.item.sections.join(', ') }}
          td {{ props.item.floors.join(', ') }}
          td {{ props.item.apartment_numbers_on_floor.join(', ') }}
          td {{ props.item.apartment_number }}
          td
            template()
              v-img(
                v-if='props.item.picture_url'
                :aspect-ratio='16/9'
                :lazy-src='props.item.picture_url'
                :src='props.item.picture_url'
                class='grey lighten-4'
                contain
              )
                v-layout(
                  slot='placeholder'
                  fill-height
                  align-center
                  justify-center
                  ma-0
                )
                  v-progress-circular(indeterminate color='primary')
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item)')
              v-icon(small) delete_outline
            s-publish-status-toggle(
              :value='props.item'
              @success='fetch'
              :resource='`advantages/${advantageId}/assignments`'
            )
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  props: ['advantageId'],

  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: true
      },
      {
        text: 'ЖК',
        align: 'left',
        value: 'complex_name',
        sortable: true
      },
      {
        text: 'Объект',
        align: 'left',
        sortable: false,
        value: 'objects_name'
      },
      {
        text: 'Подъезды',
        align: 'left',
        value: 'sections',
        width: '5%',
        sortable: true
      },
      {
        text: 'Этажи',
        value: 'floors',
        align: 'left',
        width: '5%',
        sortable: false
      },
      {
        text: 'Стояк №',
        value: 'apartment_numbers_on_floor',
        align: 'left',
        width: '5%',
        sortable: false
      },
      {
        text: 'Квартира №',
        value: 'apartment_number',
        align: 'left',
        width: '5%',
        sortable: false
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ]
  }),

  methods: {
    fetch() {
      this.fetchList({
        customUrl: `advantages/${this.advantageId}/assignments`,
        config: {
          params: this.dataFilter
        }
      })
    },

    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    changeComplex(complexId = null) {
      this.setDataFilter({ complex_id: complexId })
      this.fetch()
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Complexes.Advantages.Edit',
        params: { id, advantageId: this.advantageId }
      })
    },

    async onDelete({ id }) {
      if (await this.$confirm('Вы уверены?')) {
        try {
          await this.destroy({ customUrl: `advantages/${this.advantageId}/assignments/${id}`, id: id })
          this.fetch()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления')
        }
      }
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('objects/advantages', ['fetchList', 'destroy']),
    ...mapMutations('objects/advantages', ['setDataFilter'])
  },

  computed: {
    ...mapState('objects/advantages', ['total', 'dataFilter', 'meta']),
    ...mapGetters('objects/advantages', ['list', 'isLoading'])
  }
}
</script>

